
/* eslint-disable no-unused-expressions */
import { defineComponent, computed, onMounted, getCurrentInstance, SetupContext } from 'vue'
import useStore from './store'
import Navbar from './component/Navbar.vue'
import { ICategory } from './type'

const store = useStore(window.pinia)

export default defineComponent({
    setup (props: SetupContext['attrs'], { attrs }) {
        store.setSections(attrs.sections as ICategory[])

        const event = new CustomEvent('vue-megamenu-setup', {
            detail: {
                close: store.close,
                openCategory: store.openCategory,
            },
        })
        document.dispatchEvent(event)

        onMounted(() => {
            window.addEventListener('resize', () => {
                const instance = getCurrentInstance()
                instance?.proxy?.$forceUpdate()
            })
        })

        return {
            isOpen: computed(() => store.isOpen()),
            activeCategory: computed(() => store.getActiveCategory()),
            close: store.close,
            isWideScreen: () => !window.matchMedia('(max-width: 980px)').matches,
        }
    },
    components: {
        Navbar,
    },
})
